<template>
  <div class="content">
    <!-- Improve mortgage jumbo -->
    <Jumbo class="improve-mortgage-jumbo" reverseOnMobile>
      <template #after>
        <div class="improve-mortgage-jumbo__image">
          <ImageComponent src="img/web/improve-picto.webp" alt="Imagen mejorar hipoteca" width="624"></ImageComponent>
        </div>
      </template>

      <template #before>
        <div class="improve-mortgage-jumbo__content">
          <h2>Quiero mejorar mi hipoteca</h2>
          <p>
            <strong>¿Tienes una hipoteca y quieres mejorar las condiciones?</strong> Si quieres cambiar de un tipo variable a uno fijo, o
            simplemente crees que lo que pagas ahora mismo no se ajusta a lo que necesitas y lo que el mercado puede ofrecerte, en TRIOTECA
            nos implicaremos en tu mejora de condiciones. Los clientes que mejoraron su hipoteca con nosotros en junio de 2023 redujeron en
            233,5€ al mes de media su cuota hipotecaria.
          </p>
          <Button tag="a" :href="route('funnel.improve')" class="improve-mortgage-jumbo__content__button">
            Mejorar mi hipoteca
          </Button>
        </div>
      </template>
    </Jumbo>
  </div>
</template>

<style lang="postcss" scoped>
.content {
  @apply flex flex-col items-center bg-brand-primary-light;

  .improve-mortgage {
    &-jumbo {
      &__image {
        @apply flex justify-center items-center xl:w-4/5 mx-auto max-w-[12.25rem] lg:max-w-none;
      }

      &__content {
        @apply flex flex-col gap-y-xxs lg:pr-xl max-w-sm lg:max-w-3xl;

        h2 {
          @apply style-subtitle-bold;
        }

        p {
          @apply style-body;
        }

        &__button {
          @apply lg:self-start;
        }
      }

      /deep/ .jumbo {
        &__content {
          @apply justify-center;
        }
      }
    }
  }
}
</style>

<script>
import Jumbo from '@/lego/components/layout/Jumbo.vue';
import Button from '@/lego/components/buttons/Button.vue';
import ImageComponent from '@/lego/components/images/Image.vue';

export default {
  components: {
    Jumbo,
    Button,
    ImageComponent,
  },
};
</script>
